import React, { useState, useEffect, Fragment } from "react";

const useLeaveManagementTable = (
    leavemanagementData,
    handleDelLeaves,
    handleEditLeaves,
    onClickToggleFromTable
) => {
  const [thead] = useState(["Shift Name","In Time","Out Time", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = Array.from(leavemanagementData).map((el) => {
      return {
        "Shift Name": el.shiftName,
        "In Time": el.inTime,
        "Out Time": el.outTime,
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4" 
              style={{ marginRight: "10px", cursor: "pointer" }}             
              onClick={() => {
                handleEditLeaves(el, el.shiftId);
                onClickToggleFromTable();
             }}
            >&nbsp;</i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelLeaves(el.shiftId)}
            ></i>
            
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    leavemanagementData,
    handleDelLeaves,
    handleEditLeaves,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default useLeaveManagementTable;